import React from 'react';
import classes from './confirmDialog.module.css';

interface ConfirmDialogProps {
  title: string;
  message: string;
  confirmLabel: string;
  confirmClass?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({ title, message, confirmLabel, confirmClass, onConfirm, onCancel }: ConfirmDialogProps) {
  return (
    <div className={classes.confirmOverlay} onClick={onCancel} role="presentation">
      <div className={classes.confirmDialog} onClick={(e) => e.stopPropagation()} role="presentation">
        <h3 className={classes.confirmTitle}>{title}</h3>
        <p className={classes.confirmText}>{message}</p>
        <div className={classes.confirmActions}>
          <button type="button" className={classes.btnSecondary} onClick={onCancel}>Cancel</button>
          <button type="button" className={confirmClass || classes.btnPrimary} onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
